import React from "react";
import { gbp, pct } from "@/lib/customerApi";

export default function MonthlyTable({ rows }) {
  if (!rows?.length) return null;
  return (
    <div data-testid="bot-monthly" className="mt-5 border border-blue-900/40 bg-[#020617]/70 rounded-xl overflow-hidden">
      <div className="px-5 py-3 mono text-[10px] uppercase tracking-widest text-[#FBBF24] border-b border-blue-900/40">Month by month (every month, nothing hidden)</div>
      <div className="overflow-x-auto max-h-[420px]">
        <table className="w-full text-xs whitespace-nowrap">
          <thead className="sticky top-0 bg-[#020617]">
            <tr className="mono text-[10px] uppercase tracking-widest text-[#64748B]">
              {["Month", "P&L", "Return", "Trades", "Win rate", "Best trade", "Worst trade", "Equity at month end"].map((h) => (
                <th key={h} className="text-left px-4 py-2">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((m) => (
              <tr key={m.month} data-testid={`month-${m.month}`} className="border-t border-blue-900/20">
                <td className="px-4 py-2 mono">{m.month}</td>
                <td className={`px-4 py-2 ${m.pnl >= 0 ? "text-[#2ECA7F]" : "text-[#F87171]"}`}>{gbp(m.pnl, 2)}</td>
                <td className={`px-4 py-2 ${m.return_pct >= 0 ? "text-[#2ECA7F]" : "text-[#F87171]"}`}>{pct(m.return_pct, 2)}</td>
                <td className="px-4 py-2">{m.trades ?? "-"}</td>
                <td className="px-4 py-2">{pct(m.win_rate)}</td>
                <td className="px-4 py-2">{gbp(m.best_trade, 2)}</td>
                <td className="px-4 py-2">{gbp(m.worst_trade, 2)}</td>
                <td className="px-4 py-2">{gbp(m.end_equity)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
